// Shared configuration for the public marketing pages.
//
// There is no payment integration, so every buyer-facing CTA ends in a human
// handoff. Point REQUEST_ACCESS_PATH at whatever that handoff becomes (a
// booking link, a form, a pilot enquiry) — it is used by the nav, hero,
// pricing cards and the "bring your own conversations" block.
export const REQUEST_ACCESS_PATH = '/contact';

export const CONTRIBUTOR_PATH = '/contributors';

// Matches the address already published on the contact page.
export const CONTACT_EMAIL = 'hi@conversation-intelligence.com';

// Interview-type slug the contributor page hands off to, i.e.
// /participate/<slug>. Leave empty until an interview type exists — the page
// falls back to an email capture rather than linking into a funnel that 404s.
export const CONTRIBUTOR_FUNNEL_SLUG = '';

// Three self-serve, owner-operator verticals: the interviewee personally owns
// the account — their software, their data, their decision. The earlier
// enterprise verticals (Fintech / HR / Cybersecurity) required an employee to
// screen-record their employer's corporate system for a stranger, which no
// incentive fixes; zero interviews ever came from them. Keep the page copy
// neutral across all three — do not hard-code one vertical's examples into
// the hero.
export const VERTICALS = [
  {
    name: 'Short-term rental & property management',
    products: 'PriceLabs, Wheelhouse, Beyond, Guesty, Hostaway',
  },
  {
    name: 'E-commerce & seller tools',
    products: 'Helium 10, Jungle Scout, SellerBoard, Keepa',
  },
  {
    name: 'Creator & newsletter platforms',
    products: 'beehiiv, Kit, Substack, Ghost',
  },
];

// Concrete owner-operator Jobs, one per vertical, used wherever the copy
// needs an example.
export const JOB_EXAMPLES = [
  'Set and sync nightly prices',
  'Decide which product to source next',
  'Grow and keep paying subscribers',
];

export const INTERVIEWS_PER_PRODUCT = 10;
export const REFRESHES_PER_YEAR = 3;
